// DO NOT EDIT -- generated from fs/services/llm-tool/experiments.proto

import { ChatMessage, LlmModel } from './llm.proto';
import { Funnel, Metric, Segment } from './schema-assistant.proto';
import * as dx_objects from '../dx-objects';
import * as fieldmeta from '../fieldmeta';
import * as funnelmetrics from '../../api/metrics/funnelmetrics';
import * as metrics from '../../api/metrics';
import * as pages from '../../api/pages';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';

export namespace ExperimentsPublic {

  export const GenerateAssistantEndpoint = "/grpc/llm_tool.ExperimentsPublic/GenerateAssistant";
  export function GenerateAssistant(sender: (req: GenerateAssistantRequest, endpoint: string) => Promise<GenerateAssistantResponse>, req: GenerateAssistantRequest): { promise: () => Promise<GenerateAssistantResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateAssistantEndpoint),
      endpoint: GenerateAssistantEndpoint
    };
  }

  export const GenMetricFromPromptEndpoint = "/grpc/llm_tool.ExperimentsPublic/GenMetricFromPrompt";
  export function GenMetricFromPrompt(sender: (req: GenMetricFromPromptRequest, endpoint: string) => Promise<GenMetricFromPromptResponse>, req: GenMetricFromPromptRequest): { promise: () => Promise<GenMetricFromPromptResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenMetricFromPromptEndpoint),
      endpoint: GenMetricFromPromptEndpoint
    };
  }

  export const GenFunnelFromPromptEndpoint = "/grpc/llm_tool.ExperimentsPublic/GenFunnelFromPrompt";
  export function GenFunnelFromPrompt(sender: (req: GenFunnelFromPromptRequest, endpoint: string) => Promise<GenFunnelFromPromptResponse>, req: GenFunnelFromPromptRequest): { promise: () => Promise<GenFunnelFromPromptResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenFunnelFromPromptEndpoint),
      endpoint: GenFunnelFromPromptEndpoint
    };
  }

  export const RagEndpoint = "/grpc/llm_tool.ExperimentsPublic/Rag";
  export function Rag(sender: (req: RagRequest, endpoint: string) => Promise<RagResponse>, req: RagRequest): { promise: () => Promise<RagResponse>, endpoint: string } {
    return {
      promise: () => sender(req, RagEndpoint),
      endpoint: RagEndpoint
    };
  }

  export const StoryChatEndpoint = "/grpc/llm_tool.ExperimentsPublic/StoryChat";
  export function StoryChat(sender: (req: StoryChatRequest, endpoint: string) => Promise<StoryChatResponse>, req: StoryChatRequest): { promise: () => Promise<StoryChatResponse>, endpoint: string } {
    return {
      promise: () => sender(req, StoryChatEndpoint),
      endpoint: StoryChatEndpoint
    };
  }

  export const CreateEmbeddingEndpoint = "/grpc/llm_tool.ExperimentsPublic/CreateEmbedding";
  export function CreateEmbedding(sender: (req: CreateEmbeddingRequest, endpoint: string) => Promise<CreateEmbeddingResponse>, req: CreateEmbeddingRequest): { promise: () => Promise<CreateEmbeddingResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateEmbeddingEndpoint),
      endpoint: CreateEmbeddingEndpoint
    };
  }

  export const AskSessionEndpoint = "/grpc/llm_tool.ExperimentsPublic/AskSession";
  export function AskSession(sender: (req: AskSessionRequest, endpoint: string) => Promise<AskSessionResponse>, req: AskSessionRequest): { promise: () => Promise<AskSessionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AskSessionEndpoint),
      endpoint: AskSessionEndpoint
    };
  }
}

export namespace Experiments {

  export const RetrieveRelevantDocumentsEndpoint = "/grpc/llm_tool.Experiments/RetrieveRelevantDocuments";
  export function RetrieveRelevantDocuments(sender: (req: RetrieveRelevantDocumentsRequest, endpoint: string) => Promise<RetrieveRelevantDocumentsResponse>, req: RetrieveRelevantDocumentsRequest): { promise: () => Promise<RetrieveRelevantDocumentsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, RetrieveRelevantDocumentsEndpoint),
      endpoint: RetrieveRelevantDocumentsEndpoint
    };
  }

  export const FindUiIssuesEndpoint = "/grpc/llm_tool.Experiments/FindUiIssues";
  export function FindUiIssues(sender: (req: FindUiIssuesRequest, endpoint: string) => Promise<FindUiIssuesResponse>, req: FindUiIssuesRequest): { promise: () => Promise<FindUiIssuesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FindUiIssuesEndpoint),
      endpoint: FindUiIssuesEndpoint
    };
  }

  export const FindGhostElementsEndpoint = "/grpc/llm_tool.Experiments/FindGhostElements";
  /**
   * FindGhostElements searches through DOM snapshots for elements that have not been indexed by interactions and
   * are candidates for watched elements.
   */
  export function FindGhostElements(sender: (req: FindGhostElementsRequest, endpoint: string) => Promise<FindGhostElementsResponse>, req: FindGhostElementsRequest): { promise: () => Promise<FindGhostElementsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, FindGhostElementsEndpoint),
      endpoint: FindGhostElementsEndpoint
    };
  }

  export const GetSelectorScreenshotEndpoint = "/grpc/llm_tool.Experiments/GetSelectorScreenshot";
  /** GetSelectorScreenshot returns a screenshot URL for a recent click event matching the given selector. */
  export function GetSelectorScreenshot(sender: (req: GetSelectorScreenshotRequest, endpoint: string) => Promise<GetSelectorScreenshotResponse>, req: GetSelectorScreenshotRequest): { promise: () => Promise<GetSelectorScreenshotResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSelectorScreenshotEndpoint),
      endpoint: GetSelectorScreenshotEndpoint
    };
  }
}

export enum Agent {
  AGENT_INVALID = 0,
  AGENT_DIRK = 1,
  AGENT_AUSTIN = 2
}

export enum AssistantSchema {
  SCHEMA_INVALID = 0,
  SCHEMA_PROTO = 1,
  SCHEMA_JSON = 2,
  SCHEMA_JSON_FLAT = 3
}

export interface GenerateAssistantRequest {
  /** the conversation history */
  messages: ChatMessage[];
  llmModel: LlmModel;
  schema: AssistantSchema;
  /**
   * whether we fetch additional context, such as knowledge base documents, from
   * an index
   */
  includeContext: boolean;
  /**
   * whether we do not try to submit a second request if the first does not
   * return an object
   */
  doNotChain: boolean;
  /** Elements keyed by name, val is id */
  elements: { [key: string]: string };
}

export interface FsObject {
  segment?: segment.SegmentDefinition | null;
  metric?: metrics.Computation | null;
  funnel?: funnelmetrics.Computation | null;
  title: string;
}

export namespace FsObject {
  export enum fs_object {
    segment = 1,
    metric = 2,
    funnel = 3
  }

  export function fs_object_oneof(m: FsObject): { opt: fs_object.funnel, val: funnelmetrics.Computation } | { opt: fs_object.metric, val: metrics.Computation } | { opt: fs_object.segment, val: segment.SegmentDefinition } | null {
    if (m.segment != null) { return { opt: fs_object.segment, val: m.segment } }
    if (m.metric != null) { return { opt: fs_object.metric, val: m.metric } }
    if (m.funnel != null) { return { opt: fs_object.funnel, val: m.funnel } }
    return null;
  }
}

export interface GenerateAssistantResponse {
  rawMessage: string;
  assistantObjects: AssistantObjects | null;
  fsObjects: FsObject[];
}

export interface AssistantObjects {
  rawMessage: string;
  displayMessage: string;
  docs: ExternalContext[];
  followUps: string[];
}

export interface StructuredLlmResponse {
  thought: string;
  segments: Segment[];
  metrics: Metric[];
  funnels: Funnel[];
  urls: ExternalContext[];
  isDashboard: boolean;
  followUps: string[];
  metricsTitle: string[];
  funnelsTitle: string[];
}

export interface ExternalContext {
  content: string;
  url: string;
  title: string;
}

export interface RetrieveRelevantDocumentsRequest {
  query: string;
}

export interface RetrieveRelevantDocumentsResponse {
  documents: ExternalContext[];
}

export interface FindUiIssuesRequest {
  orgId: string;
  llmModel: LlmModel;
  pageDefId: protobuf.int64;
  /**
   * Optional timestamps to filter sessions. Can be used with sessions_before_ts
   * to get sessions between two timestamps.
   */
  sessionsAfterTs: protobuf.timestamp | null;
  /**
   * Optional timestamps to filter sessions. Can be used with sessions_after_ts
   * to get sessions between two timestamps.
   */
  sessionsBeforeTs: protobuf.timestamp | null;
  ignoreFindings: string[];
  promptOverrides: FindUiIssuesRequest.PromptOverrides | null;
}

export namespace FindUiIssuesRequest {
  export interface PromptOverrides {
    systemPrompt: string;
    /**
     * Overrides default text for part of prompt that will list out findings to
     * ignore
     */
    ignoreFindingsPrompt: string;
    outputPrompt: string;
  }
}

export interface FindUiIssuesResponse {
  originalResponse: string;
  imageLinks: string[];
  findings: FindUiIssuesResponse.Finding[];
}

export namespace FindUiIssuesResponse {
  export interface Finding {
    category: string;
    description: string;
    impact: string;
  }
}

export interface GenMetricFromPromptRequest {
  prompt: string;
  orgId: string;
}

export interface GenMetricFromPromptResponse {
  definition: dx_objects.UnnamedMetric | null;
}

export interface GenFunnelFromPromptRequest {
  prompt: string;
  orgId: string;
}

export interface GenFunnelFromPromptResponse {
  definition: dx_objects.UnnamedFunnel | null;
}

export interface RelevantObjectProperty {
  name: string;
  sampleValues: string[];
}

export interface RelevantObject {
  name: string;
  description: string;
  id: string;
  properties: RelevantObjectProperty[];
  /** only populated if the object was returned from vector search. */
  distance: number;
  recentViewCount: number;
  objectReferencesCount: number;
}

export interface RagRequest {
  prompt: string;
  orgId: string;
  elements: number;
  pages: number;
  definedEvents: number;
  segments: number;
  userProperties: number;
  metrics: number;
  funnels: number;
  apiEvents: number;
  llmRelevance?: RagRequest.LLMRelevanceStrategy | null;
  vectorSearch?: RagRequest.VectorSearchStrategy | null;
  composite?: RagRequest.CompositeStrategy | null;
  removeObjectsWithIssues: boolean;
}

export namespace RagRequest {
  export enum strategy {
    llmRelevance = 11,
    vectorSearch = 12,
    composite = 13
  }

  export function strategy_oneof(m: RagRequest): { opt: strategy.composite, val: RagRequest.CompositeStrategy } | { opt: strategy.llmRelevance, val: RagRequest.LLMRelevanceStrategy } | { opt: strategy.vectorSearch, val: RagRequest.VectorSearchStrategy } | null {
    if (m.llmRelevance != null) { return { opt: strategy.llmRelevance, val: m.llmRelevance } }
    if (m.vectorSearch != null) { return { opt: strategy.vectorSearch, val: m.vectorSearch } }
    if (m.composite != null) { return { opt: strategy.composite, val: m.composite } }
    return null;
  }

  /** (default) Lists all objects and asks LLM to pick most relevant ones */
  export interface LLMRelevanceStrategy {
  }

  /** Uses vector search distance alone to pick most relevant objects */
  export interface VectorSearchStrategy {
  }

  /** Uses LLM to expand the prompt and then uses vector search to pick the most relevant objects */
  export interface CompositeStrategy {
    /** over fetch the number of objects by this factor */
    overfetchFactor: number;
    /** number of prompts to expand the user prompt into */
    numPrompts: number;
  }
}

export interface RagResponse {
  elements: RelevantObject[];
  pages: RelevantObject[];
  definedEvents: RelevantObject[];
  segments: RelevantObject[];
  userProperties: RelevantObject[];
  metrics: RelevantObject[];
  funnels: RelevantObject[];
  apiEvents: RelevantObject[];
  hasViewAndReferenceCount: boolean;
}

export interface StoryChatRequest {
  orgId: string;
  messages: ChatMessage[];
  llmModel: LlmModel;
}

export interface Visualization {
  type: string;
  id: string;
  name: string;
  isSaved: boolean;
}

export interface RichTextMessage {
  message: string;
}

export interface PayloadAction {
  type: string;
  payload: string;
}

export enum Style {
  PRIMARY = 0,
  SECONDARY = 1
}

export interface Action {
  text: string;
  followupPrompt: string;
  payloadAction: PayloadAction | null;
  style: Style;
}

export interface MessageBlock {
  richTextMessage?: RichTextMessage | null;
  action?: Action | null;
  visualization?: Visualization | null;
}

export namespace MessageBlock {
  export enum block {
    richTextMessage = 1,
    action = 2,
    visualization = 3
  }

  export function block_oneof(m: MessageBlock): { opt: block.action, val: Action } | { opt: block.richTextMessage, val: RichTextMessage } | { opt: block.visualization, val: Visualization } | null {
    if (m.richTextMessage != null) { return { opt: block.richTextMessage, val: m.richTextMessage } }
    if (m.action != null) { return { opt: block.action, val: m.action } }
    if (m.visualization != null) { return { opt: block.visualization, val: m.visualization } }
    return null;
  }
}

export enum Layout {
  COLUMN = 0,
  ROW = 1,
  WRAP = 2
}

export interface MessageGroup {
  messageBlocks: MessageBlock[];
  layout: Layout;
}

export interface DisplayMessage {
  messageGroups: MessageGroup[];
  layout: Layout;
}

export enum ControlFlow {
  /** wait for open-ended user input */
  STOP = 0,
  /** show the response and send back to server */
  CONTINUE = 1,
  /** wait for user confirmation */
  CONFIRM = 2
}

export interface StoryChatResponse {
  /**
   * "Meta messages" keeps the state of the LLM and should not be shown to the
   * user. meta_messages returns the entire history, as the backend may add or
   * modify history.
   */
  metaMessages: ChatMessage[];
  /**
   * "Display messages" are user-facing messages and do not get fed back
   * into the LLM. display_messages returns only the net new messages, and the
   * client is responsible for keeping state.
   */
  displayMessages: DisplayMessage[];
  controlFlow: ControlFlow;
}

export interface CreateEmbeddingRequest {
  orgId: string;
  text?: string;
  metric?: search_settings.Metric | null;
  funnel?: search_settings.Funnel | null;
  segment?: search_settings.Segment | null;
  namedElement?: search_settings.NamedElement | null;
  definedEvent?: search_settings.DefinedEvent | null;
  page?: pages.PageDefinition | null;
  apiEvent?: fieldmeta.Event | null;
  userProperty?: fieldmeta.UserProperty | null;
}

export namespace CreateEmbeddingRequest {
  export enum source {
    text = 2,
    metric = 3,
    funnel = 4,
    segment = 5,
    namedElement = 6,
    definedEvent = 7,
    page = 8,
    apiEvent = 9,
    userProperty = 10
  }

  export function source_oneof(m: CreateEmbeddingRequest): { opt: source.apiEvent, val: fieldmeta.Event } | { opt: source.definedEvent, val: search_settings.DefinedEvent } | { opt: source.funnel, val: search_settings.Funnel } | { opt: source.metric, val: search_settings.Metric } | { opt: source.namedElement, val: search_settings.NamedElement } | { opt: source.page, val: pages.PageDefinition } | { opt: source.segment, val: search_settings.Segment } | { opt: source.text, val: string } | { opt: source.userProperty, val: fieldmeta.UserProperty } | null {
    if (m.text != null) { return { opt: source.text, val: m.text } }
    if (m.metric != null) { return { opt: source.metric, val: m.metric } }
    if (m.funnel != null) { return { opt: source.funnel, val: m.funnel } }
    if (m.segment != null) { return { opt: source.segment, val: m.segment } }
    if (m.namedElement != null) { return { opt: source.namedElement, val: m.namedElement } }
    if (m.definedEvent != null) { return { opt: source.definedEvent, val: m.definedEvent } }
    if (m.page != null) { return { opt: source.page, val: m.page } }
    if (m.apiEvent != null) { return { opt: source.apiEvent, val: m.apiEvent } }
    if (m.userProperty != null) { return { opt: source.userProperty, val: m.userProperty } }
    return null;
  }
}

export interface CreateEmbeddingResponse {
  embedding: number[];
  payload: string;
}

export interface FindGhostElementsRequest {
  orgId: string;
  segmentDefinition: segment.SegmentDefinition | null;
}

export interface RelevantMoment {
  eventDescription: string;
  timestamp: protobuf.timestamp | null;
}

export interface AskSessionDisplayMessage {
  message: string;
  relevantMoments: RelevantMoment[];
}

export interface AskSessionRequest {
  orgId: string;
  sessionId: string;
  userId: string;
  metaMessages: ChatMessage[];
}

export interface AskSessionResponse {
  metaMessages: ChatMessage[];
  displayMessages: AskSessionDisplayMessage[];
}

export interface DomSnapshot {
  dom: string;
  screenshotUrl: string;
  timestamp: protobuf.timestamp | null;
  eventOffset: number;
}

/** GhostSessionData consists of the dom and screenshot at a matching time, as well as for the following few seconds */
export interface GhostSessionData {
  orgId: string;
  userId: protobuf.int64;
  sessionId: protobuf.int64;
  pageId: protobuf.int64;
  domSnapshots: DomSnapshot[];
}

export interface FindGhostElementsResponse {
  sessions: GhostSessionData[];
}

export interface GetSelectorScreenshotRequest {
  orgId: string;
  selector: string;
}

export interface GetSelectorScreenshotResponse {
  orgId: string;
  userId: protobuf.int64;
  sessionId: protobuf.int64;
  pageId: protobuf.int64;
  screenshotUrl: string;
  eventOffset: number;
}
